var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandSingleDashed24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M8.13 16.5V15m-.03-2.5c-3.9 2.24-3.16 3.26-2.79 4.24 1.6 4.21 1.3 4.76 3.77 4.76h3.26c1.31 0 1.83-1.5 1.71-2.26-.23-1.43-1.2-1.23-.99-2.24l.69-2.48A1.27 1.27 0 0 0 12.52 13c-.56 0-1.05.37-1.2.9 0 0-.44 1.5-.73 3.1-.2 1.17-.98 1.5-.98 1.5M11 3H9.11c-.73 0-.98.05-.98 1v1M15 3h2.02C18 3 18 3 18 3.95V5m0 10v1c0 1 0 1-.99 1h-1.49M18 8v4M8.13 8v2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandSingleDashed24);
export default __webpack_public_path__ + "static/media/hand_single_dashed_24.4c2f835340bc74df4bc6f951ccc405c4.svg";
export { ForwardRef as ReactComponent };